export const mockData = {
  floatingImages: [
    {
      src: '/assets/chris-linnett-EeqxbxILScA-unsplash.jpg',
      title: 'Cement Factory Silos',
      description: 'Large silos storing cement at a modern factory'
    },
    {
      src: '/assets/ant-rozetsky-_qWeqqmpBpU-unsplash.jpg',
      title: 'Steel Plant Interior',
      description: 'Molten steel being poured in a steel manufacturing plant'
    },
    {
      src: '/assets/ant-rozetsky-ElwGjRAqkjA-unsplash.jpg',
      title: 'Cement Production Line',
      description: 'Industrial conveyor belts transporting raw materials'
    },
    {
      src: '/assets/ant-rozetsky-io7dX_1EFCg-unsplash.jpg',
      title: 'Steel Factory Exterior',
      description: 'Exterior view of a large steel manufacturing facility'
    },
    {
      src: '/assets/peter-herrmann-z6DJJZ1-1Cg-unsplash.jpg',
      title: 'Cement Kiln',
      description: 'Rotary kiln in a cement plant for clinker production'
    },
    {
      src: '/assets/wolfgang-weiser-50WPRo_ucFg-unsplash.jpg',
      title: 'Steel Rolling Mill',
      description: 'Hot steel being rolled into sheets at a steel mill'
    },
    {
      src: '/assets/declan-sun-5OvIgxlLlxs-unsplash.jpg',
      title: 'Cement Factory at Sunset',
      description: 'Cement plant with smoke stacks during sunset'
    },
    {
      src: '/assets/michael-pointner-7U4bTHtvTg8-unsplash.jpg',
      title: 'Steel Factory Pipes',
      description: 'Network of pipes and machinery in a steel factory'
    },
    {
      src: '/assets/christopher-burns-8KfCR12oeUM-unsplash.jpg',
      title: 'Cement Storage Facility',
      description: 'Storage domes and silos for cement products'
    },
    {
      src: '/assets/chris-linnett-EeqxbxILScA-unsplash.jpg',
      title: 'Steel Factory Night View',
      description: 'Steel plant illuminated at night with industrial lights'
    },
  ],

  employers: [
    { name: "UltraTech Cement", logo: "/assets/Ultratech_Cement_Logo.svg.png" },
    { name: "Shree Cement", logo: "/assets/Shree_Corporate_Logo.jpg" },
    { name: "ACC Limited", logo: "/assets/aditya_logo.jpg" },
    { name: "Cemex", logo: "/assets/cemex-logo.jpg" },
    { name: "Ambuja Cement", logo: "/assets/Ambuja-logo.png" },
    { name: "Dalmia Cement", logo: "/assets/Dalmia-Bharat-logo.png" },
    { name: "Tata Steel", logo: "/assets/Tata-steel-logo.png" },
    { name: "JSW", logo: "/assets/JSW_logo.png" },
    { name: "Box", logo: "/assets/Box-logo.png" },
    { name: "CDW", logo: "/assets/CDW-logo.png" },
  ],

  jobsRow1: [
    {
      title: "Mechanical Engineer",
      company: "LafargeHolcim",
      location: "Zurich, Switzerland",
      tags: ["Engineering", "Full-time", "Onsite"],
      companyLogo: "/assets/Ambuja-logo.png"
    },
    {
      title: "Plant Operations Manager",
      company: "CEMEX",
      location: "Monterrey, Mexico",
      tags: ["Operations", "Full-time", "Management"],
      companyLogo: "/assets/cemex-logo.jpg"
    },
    {
      title: "Civil Engineer (Projects)",
      company: "UltraTech Cement",
      location: "Mumbai, India",
      tags: ["Civil", "Full-time", "Onsite"],
      companyLogo: "/assets/Ultratech_Cement_Logo.svg.png"
    },
    {
      title: "Steel Production Supervisor",
      company: "ArcelorMittal",
      location: "Luxembourg City, Luxembourg",
      tags: ["Steel", "Full-time", "Supervisory"],
      companyLogo: "/assets/Tata-steel-logo.png"
    },
    {
      title: "Quality Control Inspector",
      company: "Tata Steel",
      location: "Jamshedpur, India",
      tags: ["Quality", "Full-time", "Onsite"],
      companyLogo: "/assets/Tata-steel-logo.png"
    },
    {
      title: "Maintenance Technician",
      company: "Heidelberg Materials",
      location: "Heidelberg, Germany",
      tags: ["Maintenance", "Full-time", "Factory"],
      companyLogo: "/assets/Dalmia-Bharat-logo.png"
    },
    {
      title: "Procurement Specialist",
      company: "JSW Steel",
      location: "Mumbai, India",
      tags: ["Procurement", "Full-time", "Hybrid"],
      companyLogo: "/assets/JSW_logo.png"
    }
  ],

  jobsRow2: [
    {
      title: "Process Engineer",
      company: "CEMEX",
      location: "Houston, TX",
      tags: ["Process", "Full-time", "Onsite"],
      companyLogo: "/assets/cemex-logo.jpg"
    },
    {
      title: "Structural Engineer",
      company: "ArcelorMittal",
      location: "Chicago, IL",
      tags: ["Structural", "Full-time", "Hybrid"],
      companyLogo: "/assets/Tata-steel-logo.png"
    },
    {
      title: "Safety Officer",
      company: "UltraTech Cement",
      location: "Gujarat, India",
      tags: ["Safety", "Full-time", "Onsite"],
      companyLogo: "/assets/Ultratech_Cement_Logo.svg.png"
    },
    {
      title: "Supply Chain Manager",
      company: "LafargeHolcim",
      location: "Paris, France",
      tags: ["Supply Chain", "Full-time", "Management"],
      companyLogo: "/assets/Ambuja-logo.png"
    },
    {
      title: "Industrial Electrician",
      company: "Tata Steel",
      location: "Kalinganagar, India",
      tags: ["Electrical", "Full-time", "Factory"],
      companyLogo: "/assets/Tata-steel-logo.png"
    },
    {
      title: "Environmental Compliance Officer",
      company: "Heidelberg Materials",
      location: "Ontario, Canada",
      tags: ["Environment", "Full-time", "Onsite"],
      companyLogo: "/assets/Dalmia-Bharat-logo.png"
    }
  ],

  jobsRow3: [
    {
      title: "Automation Engineer",
      company: "ArcelorMittal",
      location: "Cleveland, OH",
      tags: ["Automation", "Full-time", "Factory"],
      companyLogo: "/assets/Tata-steel-logo.png"
    },
    {
      title: "Logistics Coordinator",
      company: "LafargeHolcim",
      location: "London, UK",
      tags: ["Logistics", "Full-time", "Hybrid"],
      companyLogo: "/assets/Ambuja-logo.png"
    },
    {
      title: "Production Planner",
      company: "CEMEX",
      location: "Madrid, Spain",
      tags: ["Planning", "Full-time", "Onsite"],
      companyLogo: "/assets/cemex-logo.jpg"
    },
    {
      title: "Mining Engineer",
      company: "JSW Steel",
      location: "Karnataka, India",
      tags: ["Mining", "Full-time", "Onsite"],
      companyLogo: "/assets/JSW_logo.png"
    },
    {
      title: "Laboratory Technician",
      company: "UltraTech Cement",
      location: "Rajasthan, India",
      tags: ["Lab", "Full-time", "Onsite"],
      companyLogo: "/assets/Ultratech_Cement_Logo.svg.png"
    },
    {
      title: "Welding Specialist",
      company: "Tata Steel",
      location: "Port Talbot, UK",
      tags: ["Welding", "Full-time", "Factory"],
      companyLogo: "/assets/Tata-steel-logo.png"
    }
  ]
};
